import { render } from "./DeliveryBreakdownTable.vue?vue&type=template&id=53c04930"
import script from "./DeliveryBreakdownTable.vue?vue&type=script&lang=js"
export * from "./DeliveryBreakdownTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__